export default __webpack_public_path__ + "static/image2-f7e60f3c617938d6f487078a36dac0ac.jpeg";